// extracted by mini-css-extract-plugin
export var button = "HeroOverlay-module--button--bd0b8";
export var content = "HeroOverlay-module--content--0435e";
export var h1 = "HeroOverlay-module--h1--77f98";
export var h2 = "HeroOverlay-module--h2--b3494";
export var heroOverlay = "HeroOverlay-module--heroOverlay--40307";
export var hide = "HeroOverlay-module--hide--5644e";
export var p = "HeroOverlay-module--p--7888b";
export var video = "HeroOverlay-module--video--5f5bb";